<template>
    <Modal
      v-model="visible"
      width="960px"
      title="简历编辑"
      :closable="false"
      :footer-hide="true"
      :mask-closable="false">
      <div class="rules-content" style="padding-bottom:20px">
        <div class="ivu-table ivu-table-border apps-entry-table">
          <div class="ivu-table-body">
            <Form ref="bidingForm" :model="data" :rules="ruleData" class="user-detail">
              <h3 style="padding:20px 0">个人信息</h3>
              <table style="border:1px solid #e9eaec;border-collapse: collapse;">
                <tbody class="iv-table-tbody">
                  <tr class="ivu-table-row">
                    <th><div class="ivu-table-cell">中文姓名</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <FormItem prop="name">
                          <Input v-model="data.name" placeholder="请输入真实姓名"/>
                        </FormItem>
                      </div>
                    </td>
                    <th><div class="ivu-table-cell">英文姓名</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <Input v-model="data.ename" placeholder="请输入英文名"/>
                      </div>
                    </td>
                    <td rowspan="3" width="100" style="border:1px solid #e9eaec;text-align:center">
                      <div class="resume-avatar" style="position:relative;height:144px;left:0;top:0;background:#eee;overflow:hidden;">
                      <Upload
                          ref="upload"
                          :show-upload-list="false"
                          :default-file-list="defaultList"
                          :on-success="handleSuccess"
                          :format="['jpg','jpeg','png','gif']"
                          :max-size="2048"
                          :data="{file_type:'biding_avatar'}"
                          :headers="uploadHeaders"
                          :on-format-error="handleFormatError"
                          :on-exceeded-size="handleMaxSize"
                          :before-upload="handleBeforeUpload"
                          type="drag"
                          :action="uploadApiPath"
                           class="upload-item" style="width:114px;height:144px;margin:0">
                          <div class="upload-item-wrap" style="width:114px;height:144px;">
                              <div class="upload-item-img" style="width:114px;height:144px;">
                                  <template>
                                      <img :src="getImage(data.avatar)" style="width:100%;height:100%">
                                  </template>
                              </div>
                              <div class="upload-item-cover">
                                {{data.avatar != '' ? '编辑' : '上传照片'}}
                              </div>
                          </div>
                        </Upload>
                        <div class="upload-item-wrap" v-show="getImage(data.avatar)!=null" style="width:114px;height:144px;position:absolute;top:0;left:0">
                            <div class="upload-item-img" style="width:114px;height:144px;">
                                <template v-if="data.avatar != ''">
                                    <img :src="getImage(data.avatar)" style="width:100%;height:100%">
                                </template>
                            </div>
                        </div>
                        <!-- <input class="avatar-file" id="avatarFile" type="file" accept="image/*" capture="video" @change="handleFileChange"/>
                        <label for="avatarFile" style="position:absolute;top:0;left:0;width:100%;z-index:2">
                          <img :src="data.avatar" if="data.avatar!=null" style="width:90px;height:134px;margin:5px;">
                          <canvas class="canvas-view" :width="100*4" :height="144*4" style="visible:hidden;width:0;height:0;" id="canvasView"></canvas>
                        </label>
                        <span style="position:absolute;top:50%;left:0;width:100%;z-index:1">请选择照片</span> -->
                      </div>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th><div class="ivu-table-cell">出生年月</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <FormItem prop="birthday">
                          <Input v-model="data.birthday" placeholder="请输入您的生日"/>
                        </FormItem>
                      </div>
                    </td>
                    <th><div class="ivu-table-cell">性别</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <Select v-model="data.gender">
                          <Option value="男" label="男"></Option>
                          <Option value="女" label="女"></Option>
                        </Select>
                      </div>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th><div class="ivu-table-cell">政治面貌</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <FormItem prop="political_status" :rules="required">
                          <Input v-model="data.political_status" placeholder="政治面貌"/>
                        </FormItem>
                      </div>
                    </td>
                    <th><div class="ivu-table-cell">身高</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <FormItem prop="height" :rules="required">
                          <Input v-model="data.height" placeholder="请输入身高"/>
                        </FormItem>
                      </div>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th><div class="ivu-table-cell">所学专业</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <!-- <FormItem prop="major" :rules="required"> -->
                          <Input v-model="data.major" placeholder="请输入专业"/>
                        <!-- </FormItem> -->
                      </div>
                    </td>
                    <th><div class="ivu-table-cell">最高学历</div></th>
                    <td colspan="3">
                      <div class="ivu-table-cell">
                        <!-- <FormItem prop="education"> -->
                          <Select v-model="data.education">
                            <Option value="初中" label="初中"></Option>
                            <Option value="高中" label="高中"></Option>
                            <Option value="专科" label="专科"></Option>
                            <Option value="本科" label="本科"></Option>
                            <Option value="博士" label="博士"></Option>
                            <Option value="研究生" label="研究生"></Option>
                            <Option value="博士后" label="博士后"></Option>
                          </Select>
                        <!-- </FormItem> -->
                      </div>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th><div class="ivu-table-cell">籍贯</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <FormItem prop="origin_place" :rules="required">
                          <Input v-model="data.origin_place" placeholder="请输入籍贯"/>
                        </FormItem>
                      </div>
                    </td>
                    <th><div class="ivu-table-cell">户口所在地</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <FormItem prop="reg_place" :rules="required">
                          <Input v-model="data.reg_place" placeholder="请输入户口所在地"/>
                        </FormItem>
                      </div>
                    </td>
                    <td>
                      <!-- <div class="ivu-table-cell" style="overflow:visible">
                        <FormItem prop="reg_place" :rules="required">
                          <Select v-model="data.hkxz" placeholder="户口性质">
                            <Option value="本地农村">本地农村</Option>
                            <Option value="本地城镇">本地城镇</Option>
                            <Option value="外地农村">外地农村</Option>
                            <Option value="外地城镇">外地城镇</Option>
                          </Select>
                        </FormItem>
                      </div> -->
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th><div class="ivu-table-cell">家庭地址</div></th>
                    <td colspan="5">
                      <div class="ivu-table-cell">
                        <FormItem prop="address" :rules="required">
                          <Input v-model="data.address" placeholder="请输入您的家庭地址"/>
                        </FormItem>
                      </div>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th><div class="ivu-table-cell">家庭电话</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <FormItem prop="tel" :rules="required">
                          <Input v-model="data.tel" placeholder="请输入家庭电话"/>
                        </FormItem>
                      </div>
                    </td>
                    <th><div class="ivu-table-cell">身份证</div></th>
                    <td colspan="3">
                      <div class="ivu-table-cell">
                        <FormItem prop="id_number" :rules="required">
                          <Input v-model="data.id_number" placeholder="请输入身份证、护照号"/>
                        </FormItem>
                      </div>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th><div class="ivu-table-cell">手机号码</div></th>
                    <td>
                      <div class="ivu-table-cell">
                        <FormItem prop="mobile">
                          <Input v-model="data.mobile" placeholder="请输入手机号码"/>
                        </FormItem>
                      </div>
                    </td>
                    <th><div class="ivu-table-cell">邮箱地址</div></th>
                    <td colspan="3">
                      <div class="ivu-table-cell">
                        <FormItem prop="email">
                          <Input v-model="data.email" placeholder="请输入邮箱地址"/>
                        </FormItem>
                      </div>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th><div class="ivu-table-cell">婚姻状况</div></th>
                    <td colspan="5">
                      <div class="ivu-table-cell">
                        <FormItem prop="marital_status" :rules="required">
                          <RadioGroup v-model="data.marital_status">
                            <Radio value="未婚" label="未婚"></Radio>
                            <Radio value="已婚" label="已婚"></Radio>
                            <Radio value="离婚" label="离婚"></Radio>
                          </RadioGroup>
                        </FormItem>
                      </div>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th colspan="6" style="text-align:center"><div class="ivu-table-cell">学习经历</div></th>
                  </tr>
                  <tr>
                    <td colspan="6">
                        <table style="width:100%;border-collapse: collapse;">
                          <tbody>
                            <tr class="ivu-table-row">
                              <th style="width:130px"><div class="ivu-table-cell">时间</div></th>
                              <th style="text-align:center;width:auto"><div class="ivu-table-cell"></div></th>
                              <th style="text-align:center;width:120px"><div class="ivu-table-cell">学历</div></th>
                              <th style="text-align:center;width:120px"><div class="ivu-table-cell">专业</div></th>
                              <th style="width:40px"></th>
                            </tr>
                            <tr class="ivu-table-row" v-for="(item, index) in data.edu_exp" :key="index">
                              <td style="text-align:center">
                                <div class="ivu-table-cell">
                                  <FormItem :prop="'edu_exp.' + index + '.time'" :rules="required">
                                    <Input v-model="item.time" placeholder="如:2017.7--2018.1"/>
                                  </FormItem>
                                </div>
                              </td>
                              <td style="text-align:center">
                                <div class="ivu-table-cell">
                                  <FormItem :prop="'edu_exp.' + index + '.con'" :rules="required">
                                    <Input v-model="item.con" placeholder="学校、培训机构"/>
                                  </FormItem>
                                </div>
                              </td>
                              <td style="text-align:center">
                                <div class="ivu-table-cell">
                                  <FormItem :prop="'edu_exp.' + index + '.edu'" :rules="required">
                                    <Input v-model="item.edu" placeholder="学历"/>
                                  </FormItem>
                                </div>
                              </td>
                              <td style="text-align:center">
                                <div class="ivu-table-cell">
                                  <FormItem :prop="'edu_exp.' + index + '.major'" :rules="required">
                                    <Input v-model="item.major" placeholder="专业"/>
                                  </FormItem>
                                </div>
                              </td>
                              <td style="text-align:center">
                                <Button size="small" v-if="index>0" @click="removeItem(data.edu_exp, index)">
                                  <Icon type="md-close"></Icon>
                                </Button>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5" style="text-align:center">
                                <div class="ivu-table-cell">
                                  <Button type="default" size="small" @click="addItem('edu_exp')">
                                    <Icon type="md-add"></Icon> 增加一项
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th colspan="6" style="text-align:center"><div class="ivu-table-cell">工作经历</div></th>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <table style="width:100%;border-collapse: collapse;">
                        <tbody>
                          <tr class="ivu-table-row">
                            <th style="text-align:center;width:130px"><div class="ivu-table-cell">时间</div></th>
                            <th style="text-align:center;width:auto"><div class="ivu-table-cell">工作单位</div></th>
                            <th style="text-align:center;width:120px"><div class="ivu-table-cell">职务</div></th>
                            <th style="text-align:center;width:120px"><div class="ivu-table-cell">离职原因</div></th>
                            <th style="width:40px"></th>
                          </tr>
                        </tbody>
                        <tbody v-for="(item, index) in data.work_exp" :key="index">
                            <tr class="ivu-table-row">
                              <td style="text-align:center">
                                <div class="ivu-table-cell">
                                  <!-- <FormItem :prop="'work_exp.' + index + '.time'" :rules="required"> -->
                                    <Input v-model="item.time" placeholder="如:2017.7--2018.1"/>
                                  <!-- </FormItem> -->
                                </div>
                              </td>
                              <td style="text-align:center">
                                <div class="ivu-table-cell">
                                  <!-- <FormItem :prop="'work_exp.' + index + '.unit'" :rules="required"> -->
                                    <Input v-model="item.unit" placeholder="工作单位"/>
                                  <!-- </FormItem> -->
                                </div>
                              </td>
                              <td style="text-align:center">
                                <div class="ivu-table-cell">
                                  <!-- <FormItem :prop="'work_exp.' + index + '.post'" :rules="required"> -->
                                    <Input v-model="item.post" placeholder="职位"/>
                                  <!-- </FormItem> -->
                                </div>
                              </td>
                              <td style="text-align:center">
                                <div class="ivu-table-cell">
                                  <!-- <FormItem :prop="'work_exp.' + index + '.reason'" :rules="required"> -->
                                    <Input v-model="item.reason" placeholder="离职原因"/>
                                  <!-- </FormItem> -->
                                </div>
                              </td>
                              <td style="text-align:center">
                                <Button size="small" v-if="index>0" @click="removeItem(data.work_exp, index)">
                                  <Icon type="md-close"></Icon>
                                </Button>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5">
                                <div class="ivu-table-cell" style="padding:5px;">
                                  <Input type="textarea" v-model="item.detail" placeholder="项目经历"/>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                          <tr>
                            <td colspan="5" style="text-align:center">
                              <div class="ivu-table-cell">
                                <Button type="default" size="small" @click="addItem('work_exp')">
                                  <Icon type="md-add"></Icon> 增加一项
                                </Button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th colspan="6" style="text-align:center"><div class="ivu-table-cell">特殊技能</div></th>
                  </tr>
                  <tr class="ivu-table-row">
                    <th colspan="6" style="text-align:center"><div class="ivu-table-cell">获得的证书情况</div></th>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <table style="width:100%;border-collapse: collapse;">
                        <tbody>
                          <tr class="ivu-table-row">
                            <th style="text-align:center;width:130px"><div class="ivu-table-cell">证书名称</div></th>
                            <th style="text-align:center;width:130px"><div class="ivu-table-cell">获得时间</div></th>
                            <th style="text-align:center;width:auto"><div class="ivu-table-cell">颁发单位</div></th>
                            <th style="text-align:center;width:130px"><div class="ivu-table-cell">证书是否在公司备案</div></th>
                            <th style="width:40px"></th>
                          </tr>
                          <tr class="ivu-table-row" v-for="(item, index) in data.certificate" :key="index">
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <!-- <FormItem :prop="'certificate.' + index + '.name'" :rules="required"> -->
                                  <Input v-model="item.name" placeholder="证书名称"/>
                                <!-- </FormItem> -->
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <!-- <FormItem :prop="'certificate.' + index + '.time'" :rules="required"> -->
                                  <Input v-model="item.time" placeholder="获得时间"/>
                                <!-- </FormItem> -->
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <!-- <FormItem :prop="'certificate.' + index + '.unit'" :rules="required"> -->
                                  <Input v-model="item.unit" placeholder="颁发单位"/>
                                <!-- </FormItem> -->
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <RadioGroup v-model="item.redord">
                                  <Radio value="是" label="是"></Radio>
                                  <Radio value="否" label="否"></Radio>
                                </RadioGroup>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <Button size="small" v-if="index>0" @click="removeItem(data.certificate, index)">
                                <Icon type="md-close"></Icon>
                              </Button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5" style="text-align:center">
                              <div class="ivu-table-cell">
                                <Button type="default" size="small" @click="addItem('certificate')">
                                  <Icon type="md-add"></Icon> 增加一项
                                </Button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th colspan="6" style="text-align:center"><div class="ivu-table-cell">紧急情况联系人</div></th>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <table style="width:100%;border-collapse: collapse;">
                        <tbody>
                          <tr class="ivu-table-row">
                            <th style="text-align:center;width:100px;"><div class="ivu-table-cell">姓名</div></th>
                            <th style="text-align:center;width:100px;"><div class="ivu-table-cell">关系</div></th>
                            <th style="text-align:center;width:auto"><div class="ivu-table-cell">联系地址</div></th>
                            <th style="text-align:center;width:100px;"><div class="ivu-table-cell">联系电话</div></th>
                            <th style="text-align:center;width:100px;"><div class="ivu-table-cell">私人邮箱</div></th>
                            <th style="width:40px"></th>
                          </tr>
                          <tr class="ivu-table-row" v-for="(item, index) in data.contact" :key="index">
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <FormItem :prop="'contact.' + index + '.name'" :rules="required">
                                  <Input v-model="item.name" placeholder="联系人姓名"/>
                                </FormItem>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <FormItem :prop="'contact.' + index + '.relation'" :rules="required">
                                  <Input v-model="item.relation" placeholder="关系"/>
                                </FormItem>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <FormItem :prop="'contact.' + index + '.address'" :rules="required">
                                  <Input v-model="item.address" placeholder="联系地址"/>
                                </FormItem>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <FormItem :prop="'contact.' + index + '.tel'" :rules="required">
                                  <Input v-model="item.tel" placeholder="联系电话"/>
                                </FormItem>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                  <Input v-model="item.email" placeholder="邮箱"/>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <Button size="small" v-if="index>0" @click="removeItem(data.contact, index)">
                                <Icon type="md-close"></Icon>
                              </Button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="6" style="text-align:center">
                              <div class="ivu-table-cell">
                                <Button type="default" size="small" @click="addItem('contact')">
                                  <Icon type="md-add"></Icon> 增加一项
                                </Button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th colspan="6" style="text-align:center"><div class="ivu-table-cell">家庭成员</div></th>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <table style="width:100%;border-collapse: collapse;">
                        <tbody>
                          <tr class="ivu-table-row">
                            <th style="text-align:center;width:100px;"><div class="ivu-table-cell">姓名</div></th>
                            <th style="text-align:center;width:100px;"><div class="ivu-table-cell">关系</div></th>
                            <th style="text-align:center;width:100px;"><div class="ivu-table-cell">联系电话</div></th>
                            <th style="text-align:center;width:auto"><div class="ivu-table-cell">工作单位</div></th>
                            <th style="width:40px"></th>
                          </tr>
                          <tr class="ivu-table-row" v-for="(item, index) in data.family" :key="index">
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <FormItem :prop="'family.' + index + '.name'" :rules="required">
                                  <Input v-model="item.name" placeholder="姓名"/>
                                </FormItem>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <FormItem :prop="'family.' + index + '.relation'" :rules="required">
                                  <Input v-model="item.relation" placeholder="关系"/>
                                </FormItem>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <FormItem :prop="'family.' + index + '.tel'" :rules="required">
                                  <Input v-model="item.tel" placeholder="联系电话"/>
                                </FormItem>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <div class="ivu-table-cell">
                                <FormItem :prop="'family.' + index + '.unit'" :rules="required">
                                  <Input v-model="item.unit" placeholder="工作单位"/>
                                </FormItem>
                              </div>
                            </td>
                            <td style="text-align:center">
                              <Button size="small" v-if="index>0" @click="removeItem(data.family, index)">
                                <Icon type="md-close"></Icon>
                              </Button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5" style="text-align:center">
                              <div class="ivu-table-cell">
                                <Button type="default" size="small" @click="addItem('family')">
                                  <Icon type="md-add"></Icon> 增加一项
                                </Button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr class="ivu-table-row">
                    <th colspan="6" style="text-align:center"><div class="ivu-table-cell"> 备注</div></th>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <div class="ivu-table-cell" style="padding:8px">
                        <FormItem prop="remarks" :rules="required">
                          <Input type="textarea" v-model="data.remarks" placeholder="对将来的职业期望，努力方向"/>
                        </FormItem>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Form>
          </div>
        </div>
      </div>
      <div solt="footer" style="text-align:center">
        <Button type="primary" @click="submit">提交</Button> <Divider type="vertical" /> <Button @click="close">取消</Button>
      </div>
    </Modal>
</template>

<script>
  import {put, post} from '../fetch/api'
  import validate from '../util/validateForm'
  const baseDate = {
    edu_exp: {time: '', con: '', edu: '', major: ''},
    work_exp: {time: '', unit: '', post: '', reason: '', detail: ''},
    certificate: {name: '', time: '', unit: '', redord: '是'},
    contact: {name: '', relation: '', address: '', tel: '', email: ''},
    family: {name: '', relation: '', tel: '', unit: ''}
  }

  export default {
    name: 'BidingForm',
    components: {
      // ContractCom: resolve => { require(['../components/ContractComponent'], resolve) }
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object
      }
    },
    data () {
      let token = localStorage.getItem('token')
      const checkPhone = (rule, value, callback) => {
        let res = validate.phone(value)
        if (res !== true) {
          callback(new Error(res))
        } else {
          callback()
        }
      }
      return {
        entry_info: '',
        uploadApiPath: '/api/biding/avatar',
        defaultList: [
          {
            'name': 'a42bdcc1178e62b4694c830f028db5c0',
            'url': 'https://o5wwk8baw.qnssl.com/a42bdcc1178e62b4694c830f028db5c0/avatar'
          }
        ],
        token: token,
        uploadHeaders: {
          'Authorization': `Bearer ${token}`
        },
        userResumeAvatar: null,
        // userResume: JSON.parse(JSON.stringify(resumeData)),
        uploads: {
          id_card_f: null,
          id_card_b: null,
          education_certificate: null,
          degree_certificate: null
        },
        submitDis: false,
        maxSize: 500,
        uploadList: [],
        rulesModal: false,
        rulesIsRead: false,
        countDown: 60,
        countDownFlag: null,
        step: 0,
        steping: 0,
        required: {required: true, message: '请输入', trigger: 'blur'},
        entry_status: 0,
        ruleData: {
          birthday: [
            {required: true, message: '请输入出生日期', trigger: 'blur'}
          ],
          mobile: [
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {validator: checkPhone, trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          email: [
            {required: true, message: '请输入邮箱地址', trigger: 'change'},
            { type: 'email', message: '邮箱地址格式错误', trigger: 'blur' }
          ],
          password: [
            {required: true, min: 6, message: '请输入密码，必须大于6个字符！', trigger: 'blur'}
          ]
        }
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      close () {
        this.$emit('update:visible', false)
      },
      submitToExamine () {
        put('/console/entryStatus/1')
        // .then(res => {
        //   if (res.status === 'ok') {
        //   }
        // })
      },
      getImage (path) {
        return path ? `/api/console/file?path=${path}&token=${this.token}` : null
      },
      handleView (name) {
        this.imgName = name
        this.visible = true
      },
      handleRemove (file) {
        const fileList = this.$refs.passCardUpload.fileList
        this.$refs.passCardUpload.fileList.splice(fileList.indexOf(file), 1)
      },
      /**
        * id_card_f：身份证正面
        * id_card_b：身份证反面
        * education_certificate：学历证
        * degree_certificate：学位证
        **/
      handleSuccess (res) {
        // let path = `/api/console/file?path=${res.file.file_path}&token=${this.token}`
        this.data.avatar = res.file.file_path
      },
      handleFormatError (file) {
        this.$Notice.warning({
          title: 'The file format is incorrect',
          desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
        })
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: 'Exceeding file size limit',
          desc: 'File  ' + file.name + ' is too large, no more than 2M.'
        })
      },
      handleBeforeUpload () {
        const check = this.uploadList.length < 5
        if (!check) {
          this.$Notice.warning({
            title: 'Up to five pictures can be uploaded.'
          })
        }
        return check
      },
      startReadRules () {
        this.countDown = 10
        this.countDownFlag = setInterval(() => {
          this.countDown --
          if (this.countDown === 0) {
            clearInterval(this.countDownFlag)
          }
        }, 1000)
      },
      rulesModalOk () {
        this.rulesModal = false
        this.rulesIsRead = true
      },
      editOk () {
      },
      submit () {
        this.submitDis = true
        this.$refs.bidingForm.validate((valid) => {
          if (valid) {
            let data = JSON.parse(JSON.stringify(this.data))

            post(`/biding/save`, data).then(res => {
              if (res.status === 'ok') {
                this.$Message.success(data.id === 0 ? '添加成功' : '编辑成功')
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(res => {
              this.$Message.error(res.msg)
            })
          } else {
            this.$Message.error('请确认表单是否填写完整')
          }
        })
        setTimeout(() => {
          this.submitDis = false
        }, 10000)
      },
      handleFileChange (e) {
        if (typeof e.target === 'undefined') {
          this.file = e[0]
        } else {
          this.file = e.target.files[0]
        }
        let size = Math.floor(this.file.size / 1024)
        if (size > this.maxSize) {
          this.$Message.error(`文件大小不能超过${this.maxSize}KB`)
          return false
        }
        this.previewImage(this.file)
      },
      submitContract () {
        // let dom = document.getElementById('contractHtml')
        // let html = dom.innerHTML
        // let data = {
        //   'user_id': 0,
        //   'sign_info': JSON.stringify(this.contractData)
        // }
        // if (this.contractData.name === '') this.$Message.error('请输入乙方姓名')
        // if (this.contractData.birthday === '') this.$Message.error('请输入乙方出生日期')
        // if (this.contractData.gender === '') this.$Message.error('请输入乙方性别')
        // if (this.contractData.phone === '') this.$Message.error('请输入乙方联系电话')
        // if (this.contractData.id_number === '') this.$Message.error('请输入乙方身份证号码')
        // if (this.contractData.job_name === '') this.$Message.error('请输入您从事的工作')
        // if (this.contractData.signature === null) this.$Message.error('请您签名')
        // if (this.contractData.sign_year === '') this.$Message.error('请输入签约日期')
        // if (this.contractData.sign_month === '') this.$Message.error('请输入签约日期')
        // if (this.contractData.sign_day === '') this.$Message.error('请输入签约日期')

        // post('/users/contract', data).then(res => {
        //   if (res.status === 'ok') {
        //     this.steps(4)
        //   }
        // })

        if (this.uploads.id_card_f === null || this.uploads.id_card_f === '') {
          this.$Message.success('请上传身份证正面照片')
          return false
        }
        if (this.uploads.id_card_b === null || this.uploads.id_card_f === '') {
          this.$Message.success('请上传身份证反面照片')
          return false
        }
        this.submitToExamine()
      },
      previewImage (file) {
        let _this = this
        _this.isSubmit = false
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return
        if (/^image/.test(file.type)) {
          // 创建一个reader
          var reader = new FileReader()
          // 将图片将转成 base64 格式
          reader.readAsDataURL(file)
          // 读取成功后的回调
          reader.onload = function () {
            let img = new Image()
            img.onload = function () {
              let $canvas = document.getElementById('canvasView')
              let $ctx = $canvas.getContext('2d')
              let w = 100 * 4
              let h = 144 * 4
              $ctx.clearRect(0, 0, w, h)
              $ctx.drawImage(img, 0, 0, w, h)

              _this.data.avatar = $canvas.toDataURL()
            }
            img.src = this.result
          }
        }
      },
      addItem (name) {
        const item = JSON.parse(JSON.stringify(baseDate[name]))
        this.data[name].push(item)
      },
      removeItem (item, index) {
        item.splice(item.indexOf(item[index]), true)
      }
    }
  }
</script>
<style>
  .apps-entry-table .ivu-table-cell{padding:0 6px;}
  .apps-entry-table:after{display: none;}
  .apps-entry-table .ivu-form-item{margin:0 auto;}
  .apps-entry-table .ivu-form-item-error-tip{top:5px;right:5px;left:auto;}
  .apps-entry-table.ivu-table:before{display: none;}
  .apps-entry-table th{width:80px;text-align: right}
  .apps-entry-steps.ivu-steps .ivu-steps-head,
  .apps-entry-steps.ivu-steps .ivu-steps-title{background: none;}
  .pos-staic .ivu-form-item-content{position: static;}
</style>
<style scoped>
  .avatar-file{display: none}
  .apps-entry-steps{width:180px;float:left;padding-top:20px;}
  .apps-entry{
    width: 1030px;
    height: 100%;
    margin: 40px auto 0;

  }
  .apps-entry-content{
    margin-left: 190px;
    padding: 0;
    background-color: #fff;
    border-radius: 10px;
    min-height: 400px;
    margin-bottom: 40px;
    position: relative;
  }
  .apps-entry-title{
    margin-bottom: 10px;
  }
  .apps-entry-steps-buttons{
    padding: 5px 34px;
  }
  .rules-head{
    border-bottom: 1px solid #eee;
    padding:20px 20px 10px;
  }
  .rules-foot{
    width: 100%;
    padding: 20px 0;
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 0;
  }
  .rules-content{
    padding: 10px 20px 100px;
    border-width: 1px 0;
  }
  .rules-content h4{margin:10px 0;color:#666;}
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
  .upload-box{margin-bottom: 20px;}
  .upload-item{
    width:256px;
    display: inline-block;
    margin-left: 15px;
  }
  .upload-item-wrap{
    width: 256px;
    height: 160px;
    overflow: hidden;
    background-color: #f7f7f7
  }
  .upload-item-img,
  .upload-item-img img{height: 100%}
  .upload-item-cover{
    width: 100%;
    font-size:18px;
    color:#999;
    line-height: 40px;
    position: absolute;
    top: 60px;
  }
  .upload-item-cover i{vertical-align: middle;color:#999;}
  .contract-down{padding-top:20px;text-align: center}
  .contract-item{width:140px;display:inline-block;text-align: center;vertical-align: top;margin:0 10px;}
  .contract-item .ivu-icon{
    width: 140px;
    padding: 20px 0;
    font-size: 60px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center;
    background-color: #f1f1f1;
    margin-bottom: 10px;
  }
  .rules-book p{
    text-indent: 2em;
    color: #666;
    line-height: 2
  }
</style>
